import { type Tippy } from 'tippy.js';

export const getRectOrDestroy =
  (maybeGetRect: () => DOMRect | null, popups: () => ReturnType<Tippy>) => (): DOMRect => {
    const rect = maybeGetRect?.();
    if (!rect) {
      popups()?.forEach((popup) => popup?.destroy?.());
      return { left: 0, top: 0, bottom: 0, right: 0 } as DOMRect;
    }
    return rect;
  };
